module.exports = __webpack_public_path__ + "img/s1.287bfd2a.png";